export {FileUploadComponent} from './component';
export {UploadService} from './upload-service';
export * from './types';
